// extracted by mini-css-extract-plugin
module.exports = {"studentGuideSlider":"styles-module--studentGuideSlider--3Xopl"};